export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">联系我们</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">欢迎通过以下方式与91影视团队取得联系</p>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">bd@91yingshi.com</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">用户反馈</h3>
                <p className="text-xs text-foreground-500">feedback@91yingshi.com</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-file-add-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-500">submit@91yingshi.com</p>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-background-200 text-center">
              <p className="text-xs text-foreground-500">
                工作时间：周一至周五 9:00 - 18:00 | 我们将在24小时内回复您的来信
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}